// Icons Lucide doesn't have, drawn to match it (24 × 24, 2px rounded strokes).

import { createLucideIcon } from 'lucide-react';

/** A poo: a three-tier swirl. (Sparkles read as "AI".) */
export const PooIcon = createLucideIcon('poo', [
  ['path', { d: 'M5 20h14a2.5 2.5 0 0 0 .4-4.97A2.5 2.5 0 0 0 17 11h-1a2.5 2.5 0 0 0 .4-4.97A3 3 0 0 0 12 3c0 1.5-1 3-3 3h-.5a2.5 2.5 0 0 0-1.4 4.6A2.5 2.5 0 0 0 4.6 15.03 2.5 2.5 0 0 0 5 20Z', key: 'pile' }],
  ['path', { d: 'M8 15.5h8', key: 'tier1' }],
  ['path', { d: 'M9.5 11h4', key: 'tier2' }],
]);
